import { buildLotAltText } from "../../lib/lotAltText";

type Props = {
  image: Lot.Image;
  strings: Lot.Localizations;
  title: string;
  isFirst?: boolean;
  artist_name?: string;
  artist_lifespan?: string;
  object_type?: string;
  year?: string;
};

function imageClass(image: Lot.Image) {
  if (image.height > image.width) {
    return "portrait";
  } else {
    return "landscape";
  }
}

export default function Image(props: Props) {
  const {
    image,
    strings,
    title,
    isFirst = false,
    artist_name,
    artist_lifespan,
    object_type,
    year
  } = props;

  const alt = buildLotAltText(
    title,
    artist_name,
    artist_lifespan,
    object_type,
    year
  );

  const srcSet = [
    `${image.small} 500w`,
    `${image.medium} 800w`,
    `${image.original} 1400w`
  ].join(", ");

  const imgProps: React.ImgHTMLAttributes<HTMLImageElement> & {
    fetchpriority?: "high" | "low" | "auto";
  } = {
    src: image.medium,
    srcSet: srcSet,
    sizes: "(max-width: 768px) 100vw, 800px",
    className: imageClass(image),
    alt: alt,
    width: image.width,
    height: image.height,
    loading: "eager"
  };

  // Only first image in slider should have high priority
  if (isFirst) {
    imgProps.fetchpriority = "high";
  }

  return (
    <div className="image-wrapper">
      <div className="image">
        <img {...imgProps} />
      </div>
      <a className="press-photo" href={image.original}>
        {strings.press_photo}
      </a>
    </div>
  );
}
